const ViveEstilo = () => {
    return (
        <h1>Vive Estilo</h1>
    )
}

export default ViveEstilo